import { TASK_TRACKER_SIDEBAR_COLLAPSED_STORAGE_KEY } from '../../lib/taskTrackerSidebar.constants'
import type { SidebarSliceState } from './sidebar.types'

export const readStoredSidebarCollapsed = () => {
  if (typeof window === 'undefined') return false

  try {
    return (
      window.localStorage.getItem(TASK_TRACKER_SIDEBAR_COLLAPSED_STORAGE_KEY) ===
      '1'
    )
  } catch {
    return false
  }
}

export const writeStoredSidebarCollapsed = (collapsed: boolean) => {
  if (typeof window === 'undefined') return

  try {
    window.localStorage.setItem(
      TASK_TRACKER_SIDEBAR_COLLAPSED_STORAGE_KEY,
      collapsed ? '1' : '0',
    )
  } catch {
    // ignore quota / privacy mode errors
  }
}

export const createInitialSidebarState = (): SidebarSliceState => ({
  collapsed: readStoredSidebarCollapsed(),
})
